import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from "antd";
import FeatureComplianceRule from "./FeatureComplianceRule";
import { FeatureComplianceRuleEnum } from "./api/Representation";
export default function FeatureComplianceRuleSelect({ value = null, onChange = undefined }) {
    function onValueChanged(value) {
        if (onChange) {
            onChange(value);
        }
    }
    return (_jsx(Select, { value: value, onChange: onValueChanged, showSearch: {
            optionFilterProp: ['filter']
        }, options: FeatureComplianceRule.selectOptionsArray() }));
}
